import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';

const WorkflowTriggerModal = ({ isOpen, onRequestClose, onSelect, metricId }) => {
  const [dropdownData, setDropdownData] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  // Función para obtener los triggers según el metricId
  const fetchTriggerData = async () => {
    try {
      const response = await fetch(`http://127.0.0.1:8000/metrics_triggers_for_metric/${metricId}`);
      const data = await response.json();
      setDropdownData(data);
    } catch (error) {
      console.error("Error obteniendo los triggers:", error);
    }
  };

  useEffect(() => {
    if (isOpen && metricId) {
      fetchTriggerData();
    }
  }, [isOpen, metricId]);

  const handleSelectChange = (e) => {
    const selectedTriggerId = e.target.value;
    const selectedOption = dropdownData.find(option => option.id === parseInt(selectedTriggerId));
    setSelectedId(selectedTriggerId);
    onSelect(selectedOption);
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} ariaHideApp={false} style={{
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '20px',
        borderRadius: '10px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
      }
    }}>
      <h2>Selecciona un Trigger</h2>
      {dropdownData.length > 0 ? (
        <select onChange={handleSelectChange} value={selectedId || ''}>
          <option value="" disabled>Seleccione un trigger</option>
          {dropdownData.map(option => (
            <option key={option.id} value={option.id}>
              {option.name} - [{option.min_value} a {option.max_value}]
            </option>
          ))}
        </select>
      ) : (
        <p>No hay triggers disponibles para esta métrica.</p>
      )}
      <div style={{ marginTop: '20px' }}>
        <button onClick={onRequestClose} style={{ padding: '10px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }}>
          Cancelar
        </button>
      </div>
    </Modal>
  );
};

export default WorkflowTriggerModal;
